var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.banner.length > 0 ? _c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrappe carousel",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l(_vm.banner, function (b, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "swiper-slide"
    }, [_c('a', {
      attrs: {
        "href": b.href || '#',
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": b.img,
        "alt": ""
      }
    })])]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.banner,
      expression: "banner"
    }],
    staticClass: "swiper-pagination swiper-pagination-white",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.banner,
      expression: "banner"
    }],
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.banner,
      expression: "banner"
    }],
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };